export default "__VITE_ASSET__JU0vepvL__"